var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRuPlashka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 621.9 91.6",
    style: {
      enableBackground: "new 0 0 621.9 91.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,4.4v36.3h52.3V4.4h9v84.1h-9v-39H9v39H0V4.4H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,69.9l-8.2,18.6h-9.5L118.6,0l38.7,88.5h-9.5l-8.2-18.6H97.5z M118.6,21.6l-17.3,39.5h34.5L118.6,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,88.5V4.4h70.3v84.1h-9V13.2h-52.3v75.3H166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.7,18L254,91.6V4.4h9v63.1l53.7-63.1h9v84.1h-9V18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.3,21.9c-6.2-6.5-15-10.5-24.5-10.5c-19.1,0-34.6,15.9-34.6,35s15.5,35.1,34.6,35.1c9.6,0,18.3-4.1,24.5-10.6l6.4,6.5 c-7.9,7.9-18.9,12.9-31,12.9c-24.1,0-43.7-19.7-43.7-43.8s19.6-43.7,43.7-43.7c12.1,0,23.1,4.9,31,12.9L407.3,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.2,69.9L425,88.5h-9.5L454.3,0L493,88.5h-9.5l-8.2-18.6H433.2z M454.3,21.6L437,61.1h34.5L454.3,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.1,4.4v8.8h-30v75.3h-9V13.2h-30V4.4H550.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598,40.7c13.2,0,23.9,10.7,23.9,23.9S611.2,88.5,598,88.5h-38.3V4.4h9v36.3L598,40.7L598,40.7z M568.7,79.7h29.1 c8.4,0,15.1-6.7,15.1-15.1c0-10.3-8-15.1-17.3-15.1h-26.9L568.7,79.7L568.7,79.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuPlashka);
export default __webpack_public_path__ + "static/media/RU_PLASHKA_написать.c0c5e475ec11c013bdba5f8326321b43.svg";
export { ForwardRef as ReactComponent };